"use client";

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import {useToast} from "@/hooks/useToast";

export function Toaster() {
  const {toasts} = useToast();

  return (
    <div className="absolute max-w-full">
      <ToastProvider>
        {toasts.map(function ({
          id,
          title,
          description,
          icon,
          action,
          duration,
          ...props
        }) {
          return (
            <Toast key={id} duration={duration} {...props}>
              <div className="flex flex-col w-full">
                <div className="flex justify-center items-center w-full gap-2">
                  <div className="flex items-center justify-center">
                    {icon}
                    {title && <ToastTitle>{title}</ToastTitle>}
                    {description && (
                      <ToastDescription>{description}</ToastDescription>
                    )}
                  </div>
                  {action}
                </div>
                <ToastClose />
              </div>
            </Toast>
          );
        })}
        <ToastViewport />
      </ToastProvider>
    </div>
  );
}
